import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js'

const gltfLoader = new GLTFLoader()

export default async function loadGLTF(url) {
    return new Promise((resolve, reject) => {
        gltfLoader.load(url, resolve, undefined, reject)
    })
}

loadGLTF.initDRACOLoader = () => {
    const draco = new DRACOLoader()
    draco.setDecoderPath(import.meta.env.BASE_URL + 'loader/draco/')
    draco.preload()
    gltfLoader.setDRACOLoader(draco)
}

loadGLTF.loader = {
    name: 'gltf',
    extensions: ['.gltf', '.glb'],
}
